import GenericForm from "../../external/ensolvers-core-frontend-mui/components/Common/GenericForm";
import { SpinnerWrapper } from "../SpinnerWrapper";
import Certification from "../../models/Certification";
import { CertificationLevel } from "../../utils/enums/Certification/CertificationLevel";
import { Typography } from "@material-ui/core";
import OpsAvatarComponent from "../OpsAvatarComponent";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import { ColorUtils } from "../../utils/ColorUtils";

interface Props {
  viewCertification: Certification;
  onClose: () => void;
  isLoading: boolean;
}

export default function CertificationViewDialog(props: Props) {

  return (
    <GenericForm<Certification>
      headerStyles={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom:-10, marginTop:10 }}
      buttonStyles={{ marginRight: 20, color: 'white', backgroundColor: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom: 10 }}
      additionalButtonStyles={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, border: `1px solid ${ColorUtils.ENSOLVERS_ORANGE_REBRANDING}`, marginBottom: 10 }}
      dialog={true}
      open={!!props.viewCertification}
      instance={props.viewCertification!}
      title={props.viewCertification.badgeName}
      onSave={() => props.onClose()}
      dialogCustomSubmitMessage={"Close"}
      hideCancel={true}
      disableBackdropClick
      renderContent={(register, errors, control) => (
        <>
          <SpinnerWrapper isLoading={props.isLoading}>
            <div className="mx-auto d-flex justify-content-center" style={{ marginTop: "2em", marginBottom: "2em" }}>
              <OpsAvatarComponent
                avatarUrl={
                  props.viewCertification.badge && props.viewCertification.badge.iconUrl ? props.viewCertification.badge.iconUrl : ""
                }
                forceGenericAvatar={true}
                genericAvatar={<NoPhotographyIcon sx={{ width: "4em", height: "4em" }} />}
                sx={{ width: "6.5em", height: "6.5em", marginBottom: "1em" }}
                customStyle={{ maxWidth: "50%", display: "flex", justifyContent: "center", margin: "auto" }}
              />
            </div>

            {props.viewCertification.badge.level && (
              <Typography style={{ marginLeft: "1em", marginBottom: "1em" }}>
                Level: {CertificationLevel[props.viewCertification.level as keyof typeof CertificationLevel]}
              </Typography>
            )}

            <Typography style={{ marginLeft: "1em" }}>{props.viewCertification.badge.description}</Typography>
          </SpinnerWrapper>
        </>
      )}
    />
  );
}
